<template lang="pug">
	.form-group.fg-offer
		.d-flex.justify-content-between
			label OS Version
		multiselect(:multiple="multiple", :options="versionOptions", :value="value",
			:limit="1", group-label="name", group-values="items", :group-select="false", @input="onChange",
			track-by="id", label="name", deselect-label="", select-label="",
			:internal-search="false", @open="selectVersionsFilter")

</template>
<script>
import Vue from 'vue';
import SelectOsVersionModal from '../../views/modals/SelectOsVersionModal';  

export default {
  name: 'SelectOsVersion',
  props: {
    value: {
      type: [Array],
    },
    multiple: {
      type: [Boolean],
      default() {
        return true;
      },
    },
  },

  data() {
    return {
      versionOptions: [],
    };
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
    selectVersionsFilter() {
      let selectedVersions = this.value;
      this.$modal.show(
        SelectOsVersionModal,
        {
          selectedVersions,
          multiple: this.multiple,
        },
        {
          height: '90%',
          width: '90%',
          minWidth: 500,
        },
        {
          'before-close': (/*event*/) => {
            this.$emit('input', selectedVersions);
          },
        },
      );
    },
  },
};
</script>
